import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3v5m4 4h5","key":"svg-0"}],["path",{"d":"M8 12a4 4 0 1 0 8 0a4 4 0 1 0 -8 0","key":"svg-1"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-2"}]]

const IconChartDonut2 = createReactComponent('outline', 'chart-donut-2', 'ChartDonut2', __iconNode);

export default IconChartDonut2;